import { useEffect } from 'react'
import {
  ActivityIndicator,
  Image,
  Linking,
  useWindowDimensions,
} from 'react-native'

import { i18n } from '@localization'
import { publishEvent } from '@zet/analytics'
import { Button } from '@zet/design-system/button'
import { Icon } from '@zet/design-system/icons'
import { Stack, XStack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import Whatsapp from '@zet/design-system/svg/Whatsapp'
import { B2, SH3 } from '@zet/design-system/typography'
import ShareFilled from '@zet/svg/shareFilled'
import { ModalStackParams } from 'modals/modalConfig'
import { ModalComponentProp } from 'react-native-modalfy'

type Props = ModalComponentProp<ModalStackParams, void, 'WebFlowApplyModal'>
const WebFlowApplyModal = ({ modal: { closeModal, getParam } }: Props) => {
  const { width } = useWindowDimensions()
  const brandName = getParam('brandName')
  const brandLogo = getParam('brandLogo')
  const brandLink = getParam('brandLink')
  const brandCategoryId = getParam('brandCategoryId')
  const customerPhoneNumber = getParam('customerPhoneNumber')
  const modalType = getParam('modalType')
  const displayContent = getParam('displayContent')
  const whatsappShareTemplate = getParam('whatsappShareTemplate')
  const openJFSLinkWithModal = getParam('openJFSLinkWithModal')

  useEffect(() => {
    const setTimeOutTimer = setTimeout(() => {
      if (modalType === 'redirect') {
        if (openJFSLinkWithModal) {
          window.location.href = brandLink
          closeModal()
        } else {
          const open = window.open(brandLink)
          if (open == null || typeof open == 'undefined') {
            window.location.href = brandLink
            closeModal()
          }
          closeModal()
        }
      }
    }, 1000)
    return () => clearTimeout(setTimeOutTimer)
  }, [])

  return (
    <Stack>
      {modalType === 'apply' ? (
        <Stack
          className="rounded bg-white"
          style={{ width: width > 640 ? 615 : width - 32 }}
        >
          <XStack className="px-3 py-2">
            <ShareFilled className="mt-1" />
            <SH3 className="ml-3 flex-grow " numberOfLines={1}>
              {brandName}
            </SH3>
            <Pressable onPress={closeModal}>
              <Icon type="Close" />
            </Pressable>
          </XStack>
          <Stack
            style={{
              height: 50,
              width: 100,
            }}
            className="self-center"
          >
            {Boolean(brandLogo) && (
              <Image
                source={{ uri: brandLogo }}
                style={{
                  flex: 1,
                }}
                resizeMode={'contain'}
              />
            )}
          </Stack>
          <Stack className="mx-3 px-4">
            {displayContent ? (
              <B2 className="text-grays-60">{displayContent}</B2>
            ) : (
              <B2 className="text-grays-60 text-center leading-tight">
                {i18n.t('webFlowApplyModal.subHeading')}
              </B2>
            )}
          </Stack>
          <Stack className="border-grays-30 mt-3 border-t px-3 py-2">
            <Button
              className="w-full"
              textStyle="font-[Graphie-SemiBold]"
              size="lg"
              intent={'success'}
              iconLeft={<Whatsapp color="white" />}
              eventName="click_action"
              eventPayload={{
                sheet_name: 'apply_bottom_sheet_share_via_whatsapp',
                brand_name: brandName,
                brand_CategoryId: brandCategoryId,
              }}
              onPress={() => {
                Linking.openURL(
                  `https://api.whatsapp.com/send?text=${
                    whatsappShareTemplate ??
                    i18n.t('webFlowApplyModal.whatsAppTemplate', {
                      brandLink: brandLink,
                    })
                  }&phone=+91${
                    String(customerPhoneNumber).length > 10
                      ? customerPhoneNumber?.slice(2)
                      : customerPhoneNumber
                  }`
                )
                closeModal()
                publishEvent('click_action', {
                  item_name: 'apply_bottom_sheet_share_on_whatsapp_succesful',
                  brand_name: brandName,
                  brand_CategoryId: brandCategoryId,
                })
              }}
            >
              {i18n.t('webFlowApplyModal.shareTitle')}
            </Button>
          </Stack>
        </Stack>
      ) : (
        <Stack className="rounded bg-white py-3" style={{ width: width - 32 }}>
          <ActivityIndicator />
          <Stack className="mx-3 mt-6 px-4">
            <B2 className="text-grays-60 text-center leading-tight">
              {i18n.t('webFlowApplyModal.redirectionText', {
                brandName: brandName,
              })}
            </B2>
          </Stack>
        </Stack>
      )}
    </Stack>
  )
}
export default WebFlowApplyModal
